import { z } from "zod";
import { ReportJourneyItemType } from './enums';
import { FormJourneyItem } from "./leadForm";

export const ReportItemChoiceSubValue = z.object({
  option: z.string(),
  count: z.number(),
  percentage: z.number(),
})
export type ReportItemChoiceSubValue = z.infer<typeof ReportItemChoiceSubValue>;

export const ReportItemChoiceValue = z.object({
  option: z.string(),
  count: z.number(),
  percentage: z.number(),
  /** When option is the aggregate "Other" bucket, per–free-text breakdown */
  subChoices: z.array(ReportItemChoiceSubValue).optional(),
})
export type ReportItemChoiceValue = z.infer<typeof ReportItemChoiceValue>;

export const ReportItemTextValue = z.union([
  z.array(z.string()),
  z.array(z.array(z.string()))
])
export type ReportItemTextValue = z.infer<typeof ReportItemTextValue>;

export const ReportItemInsight = z.object({
  description: z.string(),
  keyPoints: z.array(z.string()),
})
export type ReportItemInsight = z.infer<typeof ReportItemInsight>;

export const ReportStatus = z.enum(['excellent', 'good', 'average', 'not well'])
export type ReportStatus = z.infer<typeof ReportStatus>

export const ReportItemKeyDetails = z.object({
  status: ReportStatus,
  summary: z.string(),
  keyTakeaways: z.array(z.string()),
})
export type ReportItemKeyDetails = z.infer<typeof ReportItemKeyDetails>

export const ReportItem = z.discriminatedUnion('type', [
  z.object({
    id: z.string(),
    summary: z.string(),
    journeyItemId: z.string(),
    totalResponses: z.number(),
    visible: z.boolean(),
    type: z.literal('TEXT'),
    value: ReportItemTextValue,
    keyTakeaways: ReportItemInsight.nullable(),
    journeyItem: FormJourneyItem.nullish(),
  }),
  z.object({
    id: z.string(),
    summary: z.string(),
    journeyItemId: z.string(),
    totalResponses: z.number(),
    visible: z.boolean(),
    type: z.literal('CHOICE'),
    value: z.array(ReportItemChoiceValue),
    keyTakeaways: ReportItemInsight.nullable(),
    journeyItem: FormJourneyItem.nullish(),
  }),
]);
export type ReportItem = z.infer<typeof ReportItem>;

export const ReportGenerationStatus = z.enum(['NO_AI_INSIGHT', 'VOLUME_TOO_LOW', 'WITH_AI_INSIGHT'])
export type ReportGenerationStatus = z.infer<typeof ReportGenerationStatus>

export const Report = z.object({
  id: z.string(),
  name: z.string(),
  numberOfResponses: z.number(),
  publicId: z.string(),
  enableLink: z.boolean(),
  converImageUrl: z.string().nullable(),
  logoUrl: z.string().nullish(),
  formId: z.string(),
  items: z.array(ReportItem),
  summary: z.string().nullable(),
  keyTakeaways: z.array(z.string()).nullable(),
  updatedAt: z.date().nullish(),
  reportGenerationStatus: ReportGenerationStatus,
});
export type Report = z.infer<typeof Report>;